import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translation } from '@core/locales';
import { Box, factory, LoadingOverlay, Prompt, Stack, Text } from '@coveord/plasma-mantine';
import { Children, isValidElement, useMemo } from 'react';
import { Locales } from '../../../strings/Locales.js';
import { PromptProjectsSection } from '../PromptProjectsSection.js';
import classes from './EditConfirmationPrompt.module.css';
import { EditConfirmationPromptCancelButton } from './EditConfirmationPromptCancelButton.js';
import { EditConfirmationPromptConfirmButton } from './EditConfirmationPromptConfirmButton.js';
export var EditConfirmationPrompt = factory(function(props, ref) {
    var _ref, _ref1, _projects_isLoading, _projects_isLoading1;
    var _projects_data, _projects_data1;
    var onClose = props.onClose, opened = props.opened, resourceName = props.resourceName, resourceType = props.resourceType, projects = props.projects, description = props.description, errorDescription = props.errorDescription, additionalDescription = props.additionalDescription, title = props.title, children = props.children, promptProps = _object_without_properties(props, [
        "onClose",
        "opened",
        "resourceName",
        "resourceType",
        "projects",
        "description",
        "errorDescription",
        "additionalDescription",
        "title",
        "children"
    ]);
    var projectsCount = (_ref = (_projects_data = projects.data) === null || _projects_data === void 0 ? void 0 : _projects_data.length) !== null && _ref !== void 0 ? _ref : 0;
    var hasProjectsList = ((_ref1 = (_projects_data1 = projects.data) === null || _projects_data1 === void 0 ? void 0 : _projects_data1.length) !== null && _ref1 !== void 0 ? _ref1 : 0) > 0 || ((_projects_isLoading = projects.isLoading) !== null && _projects_isLoading !== void 0 ? _projects_isLoading : false);
    var resolvedTitle = title !== null && title !== void 0 ? title : Locales.format('EditConfirmationPrompt.title', {
        resourceType: resourceType
    });
    var promptButtons = useMemo(function() {
        return Children.toArray(children).filter(function(child) {
            return /*#__PURE__*/ isValidElement(child) && (child.type === EditConfirmationPromptCancelButton || child.type === EditConfirmationPromptConfirmButton);
        });
    }, [
        children
    ]);
    var resolvedDescription;
    if (!projects.isError && hasProjectsList && description) {
        resolvedDescription = /*#__PURE__*/ _jsx(Text, {
            children: description
        });
    } else if (!projects.isError && hasProjectsList) {
        resolvedDescription = /*#__PURE__*/ _jsx(Text, {
            children: /*#__PURE__*/ _jsx(Translation, {
                t: Locales,
                i18nKey: 'EditConfirmationPrompt.description',
                options: {
                    resourceType: resourceType,
                    resourceName: resourceName,
                    smart_count: projectsCount
                },
                children: /*#__PURE__*/ _jsx(Text, {
                    inherit: true,
                    span: true,
                    fw: 500,
                    className: classes.root
                })
            })
        });
    } else if (errorDescription) {
        resolvedDescription = /*#__PURE__*/ _jsx(Text, {
            children: errorDescription
        });
    } else {
        resolvedDescription = /*#__PURE__*/ _jsx(Text, {
            children: /*#__PURE__*/ _jsx(Translation, {
                t: Locales,
                i18nKey: 'EditConfirmationPrompt.description.error',
                options: {
                    resourceType: resourceType,
                    resourceName: resourceName
                },
                children: /*#__PURE__*/ _jsx(Text, {
                    inherit: true,
                    span: true,
                    fw: 500,
                    className: classes.root
                })
            })
        });
    }
    return /*#__PURE__*/ _jsxs(Prompt.Information, _object_spread_props(_object_spread({
        title: resolvedTitle,
        opened: opened,
        onClose: onClose,
        ref: ref
    }, promptProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ _jsx(LoadingOverlay, {
                        visible: (_projects_isLoading1 = projects.isLoading) !== null && _projects_isLoading1 !== void 0 ? _projects_isLoading1 : false,
                        "data-testid": "edit-confirmation-prompt-projects-loading-overlay"
                    }),
                    resolvedDescription,
                    /*#__PURE__*/ _jsx(PromptProjectsSection, {
                        projects: projects
                    }),
                    additionalDescription && /*#__PURE__*/ _jsx(Box, {
                        "data-testid": "edit-confirmation-prompt-additional-description",
                        children: additionalDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Prompt.Footer, {
                children: promptButtons
            })
        ]
    }));
});
EditConfirmationPrompt.CancelButton = EditConfirmationPromptCancelButton;
EditConfirmationPrompt.ConfirmButton = EditConfirmationPromptConfirmButton;
EditConfirmationPrompt.displayName = 'EditConfirmationPrompt';

//# sourceMappingURL=EditConfirmationPrompt.js.map